import { render, staticRenderFns } from "./date-filter.vue?vue&type=template&id=640f936f&"
import script from "./date-filter.vue?vue&type=script&lang=js&"
export * from "./date-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "date-filter.vue"
export default component.exports